import React from 'react';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import i18next from 'i18next';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import Link from '@material-ui/core/Link';
import { useTranslation } from 'react-i18next';
import './ContactSupportTranslate';
import config from '../../_helpers/config';

function ContactSupportPage() {
  const { t } = useTranslation();
  const breadCrumbItems = [
    { name: i18next.t('breadcrumbs_home'), href: '/' },
    { name: i18next.t('breadcrumbs_contactSupport') }
  ];
  return (
    <div>
      <BreadCrumbs items={breadCrumbItems} />
      <Paper className="pb3 pt1 px3">
        <h3>{t('contactSupport_title')}</h3>
        <Divider />
        <div className="mt2">
          {(config.code === 'Almaty' || config.code === 'Zhetisu') && (
            <div>
              {t('contactSupport_eZhetysu')}{' '}
              <Link href="https://youtrack.dlife.kz/form/300fdec1-bdeb-40c5-b5df-34238afefc27">
                gu.almobl.supports
              </Link>
            </div>
          )}
          <div>
            {t('contactSupport_telephones')}{' '}
            <div>
              <span className="bold">
                <a href="tel:+7 747 942 7127">+7 747 942 7127</a>{' '}
              </span>
              Ержан, Махаббат
            </div>
          </div>

          <div>{t('contactSupport_timeWork')}</div>
          <div>{t('contactSupport_timeLunch')}</div>
          <br />
          <br />
          <span className="bold"> {t('contactSupport_description')} </span>
          <div>{t('contactSupport_step1')}</div>
          <div>{t('contactSupport_step2')}</div>
          <div>{t('contactSupport_step3')}</div>
          <ul>
            <li>{t('contactSupport_problemDescription')}</li>
            <li>{t('contactSupport_additionalMaterials')}</li>
          </ul>
          <div>{t('contactSupport_step4')}</div>
          <div>{t('contactSupport_example')}</div>
        </div>
      </Paper>
    </div>
  );
}

export default ContactSupportPage;
